import EmailEditCard from '../EmailEditCard'

import './styles.styl'

const EmailMessage = ({
  message,
  headline,
  renderSelectedUser,
  emailMessage,
  dynamicAccountSendAttribute,
  actions: { setSenderName, setMessage, setHeadline, setAuthorId, setEmailOverride },
}) => (
  <div className="playbook-message">
    <div>
      <h2>Customize the message your users will see.</h2>
      <h3>What do you want to say? Keep it short and sweet, be personal and human!</h3>
    </div>
    <EmailEditCard
      title={"Email"}
      description={headline}
      message={message}
      setSenderName={setSenderName}
      setMessage={setMessage}
      setHeadline={setHeadline}
      setAuthorId={setAuthorId}
      setEmailOverride={setEmailOverride}
      renderSelectedUser={renderSelectedUser}
      dynamicAccountSendAttribute={dynamicAccountSendAttribute}
      emailMessage={emailMessage}
      includeSenderSelect={true}
      includeInboxEmails={true}
    />
  </div>
)

export default EmailMessage



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailMessage/component.js